<script>
    import {fade} from 'svelte/transition';
    import MobSlider from './program_slider_mob.svelte';
    $: innerWidth = 2000;
    export let slides;
    let currentAnim = 'start';
    let cur = 0;
    const clamp = (number, min, max) => Math.min(Math.max(number, min), max);
    /**
     *
     * @param {object}e
     */
    function prev(e) {
        cur = clamp(--cur, 0, slides.length - 1);

        if (cur === 0) {
            currentAnim = 'start';
        } else if (currentAnim === 'nextSlide') {
            currentAnim = 'slidePrev';
        } else if (currentAnim === 'slidePrev' || cur > 0) {
            currentAnim = 'nextSlide';
        }
    }
    /**
     *
     * @param {object}e
     */
    function next(e) {
        if (cur === slides.length - 1) {
            cur = 0;
        } else {
            cur = clamp(++cur, 0, slides.length - 1);
        }

        if (cur === 0) {
            currentAnim = 'start';
        } else if (currentAnim === 'nextSlide') {
            currentAnim = 'slidePrev';
        } else if (currentAnim === 'slidePrev' || cur > 0) {
            currentAnim = 'nextSlide';
        }
    }
    const ARROW_LEFT = 37;
    const ARROW_RIGHT = 39;
    /**
     *
     * @param {object}e
     */
    function handleShortcut(e) {
        if (e.keyCode === ARROW_LEFT) {
            prev();
        }
        if (e.keyCode === ARROW_RIGHT) {
            next();
        }
    }
</script>

<svelte:window on:keyup={handleShortcut} />
<div class="desktop">
    <div class="extra-outer-wrapper">
        <div class="outer-wrapper">
            <div class="inner-wrapper">
                <div class="slide-background">
                    <div class="slide">
                        {#each slides as slide, id}
                            <div
                                class="main_div"
                                transition:fade={{duration: 200}}
                            >
                                <div class="outer_div {currentAnim}">
                                    <div class="slide-inner">
                                        <div class="img-slider">
                                            {#if innerWidth < 1025}
                                                <img
                                                    src={slide.mobile_image}
                                                    alt=""
                                                />
                                            {:else}
                                                <img src={slide.image} alt="" />
                                            {/if}
                                        </div>
                                        <div class="content-slider">
                                            <div class="content-slideno">
                                                <p style="padding:0;">
                                                    {id + 1}
                                                </p>
                                            </div>
                                            <div class="head-slider">
                                                <p>{@html slide.heading}</p>
                                            </div>
                                            <hr class="new4" />
                                            <div class="time-slider">
                                                {#if slide.time != ''}
                                                    <ul>
                                                        <li>{slide.time}</li>
                                                    </ul>
                                                {/if}
                                            </div>
                                            <div class="text-slider">
                                                <p>{@html slide.content}</p>
                                            </div>
                                            <div class="button">
                                                <button
                                                    class="learnbtn-desktop"
                                                    on:click={(location.href =
                                                        slide.link)}
                                                >
                                                    Learn More
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
                <div class="controls">
                    {#if cur != 0}
                        <button
                            class="button1"
                            on:click={() => {
                                prev();
                            }}
                        >
                            <img
                                src="images/fundamental_programs/next_button.svg"
                                alt=""
                                width="100%"
                            />
                        </button>
                    {/if}
                    {#if slides.length != 1}
                        <button
                            class="button2"
                            on:click={() => {
                                next();
                            }}
                        >
                            <img
                                src="images/fundamental_programs/next_button.svg"
                                alt=""
                                width="100%"
                            />
                        </button>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>
<div class="mobile">
    <MobSlider slidesMob={slides} />
</div>

<style>
    .learnbtn-desktop {
        color: white;
        width: 9.097vw;
        border: none;
        height: 3.652vw;
        font-size: 0.93vw;
        background: rgba(60, 116, 192, 1);
    }

    .extra-outer-wrapper {
        width: 100%;
        margin: 0 auto;
        font-family: "Inter";
    }
    .outer-wrapper {
        width: 100%;
        padding: 0 0 56.25%;
        position: relative;
    }
    .inner-wrapper {
        height: 100%;
        width: 100%;
        display: flex;
        position: absolute;
        z-index: 0;
        overflow: hidden;
    }
    .controls {
        text-align: center;
        width: 100%;
        display: block;
    }
    .controls .button1 {
        position: absolute;
        left: 8vw;
        top: 23.206vw;
        width: 2vw;
        height: 4vw;
        transform: rotateY(180deg);
        background: none;
        border: none;
    }
    .controls .button2 {
        position: absolute;
        right: 8vw;
        top: 23.206vw;
        width: 2vw;
        height: 4vw;
        background: none;
        border: none;
    }
    .slide-background {
        margin-top: 4.42vw;
        flex: 1 0 auto;
        align-items: center;
        text-align: center;
        width: 76.653vw;
        height: 41.799vw;
        margin-left: 10.251vw;
        border-radius: 2.6vw;
        border-top-left-radius: 0vw;
        border: 0.198vw solid #7cc1ff;
        border-bottom-left-radius: 0vw;
        border-left: none;
    }
    .slide-background::after {
        content: "";
        height: 1.518vw;
        width: 1.518vw;
        background-color: #f7e05f;
        border-radius: 50%;
        position: absolute;
        top: 3.85vw;
        left: 16vw;
    }

    .slide {
        display: flex;
        gap: 12vw;
        align-items: center;
        text-align: center;
    }
    .slide-inner {
        justify-content: center;
        margin: auto;
        flex: 1 0 auto;
        width: 96%;
        height: 80%;
        align-items: center;
        display: flex;
        text-align: center;
        font-weight: bold;
        color: black;
        gap: 7vw;
    }
    .main_div {
        transition: transform 5s, opacity 2s;
    }
    .main_div .start {
        transform: translate(-5vw);
        transition-duration: 0.5s;
        opacity: 1;
    }
    .main_div .nextSlide {
        transform: translate(-98vw);
        transition-duration: 0.5s;
        opacity: 1;
    }
    .main_div .slidePrev {
        transform: translate(-191vw);
        transition-duration: 0.5s;
        opacity: 1;
    }
    .img-slider {
        margin-left: 7vw;
        width: 19.18vw;
        height: 29.762vw;
        margin-top: 5.82vw;
    }
    .img-slider img {
        width: 100%;
        height: 100%;
        border-radius: 1.992vw;
    }
    .content-slider {
        height: 32vw;
        width: 45vw;
        margin-right: 6vw;
        z-index: 0;
    }
    .content-slideno {
        margin-left: -25.2vw;
        z-index: 1;
        background-color: #f7e05f;
        width: 5.017vw;
        height: 5.423vw;
        margin-top: 4vw;
        padding-top: 0.8vw;
        border-radius: 1.8vw 0vw 2vw 0.08vw;
    }
    .content-slideno p {
        font-size: 2.513vw;
        padding-left: 1vw;
    }
    .head-slider {
        width: 28vw;
        text-align: start;
        margin-top: -6vw;
        color: rgba(0, 32, 75, 1);
    }
    .head-slider p {
        font-size: 1.984vw;
        font-weight: 500;
        margin-bottom: 0;
    }
    hr.new4 {
        color: #f7e05f;
        margin-top: 1vw;
        margin-bottom: 1vw;
        opacity: 1;
        margin-right: 14vw;
    }
    .time-slider {
        height: 1.3vw;
        width: fit-content;
        margin-right: 0;
    }
    .time-slider ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .time-slider ul li::before {
        content: "\2022";
        color: #7cc1ff;
        font-weight: bold;
        display: inline-block;
        width: 1.5vw;
        margin: 0;
        padding: 0;
    }
    .time-slider ul li {
        font-size: 0.926vw;
        font-weight: 500;
        margin: 0;
        padding: 0;
    }
    .text-slider {
        width: 34.722vw;
        height: 16.2vw;
        margin-top: 2vw;
        color: rgba(0, 32, 75, 1);
    }
    .text-slider p {
        font-size: 1.19vw;
        font-weight: 400;
        text-align: start;
    }
    .button {
        background-color: #3c74c0;
        color: white;
        border-radius: 1.5625vw;
        width: 8.334vw;
        height: 2.82vw;
        display: flex;
        gap: 1vw;
        align-content: center;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
    }
</style>
